/*** IMPORTS FROM imports-loader ***/
var define = false;

module.exports = function (done, value) {
  return { value: value, done: !!done };
};

